import { ComponentContainerHeader } from './ComponentContainerHeader';

export default ComponentContainerHeader;